import React, { memo } from "react";
import { withNamespaces } from "react-i18next";
import { Card, CardBody, CardTitle } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const MitigatedAndAcceptedRisksCreated = memo(
    ({ t, createdRisksAndTasks, mitigatedAndAcceptedRisks, isFetching }) => {
        const totalCreated = Number(createdRisksAndTasks?.allCreatedRisksCount ?? mitigatedAndAcceptedRisks?.totalRisks ?? 0);
        const totalMitigated = Number(createdRisksAndTasks?.allMitigatedRisksCount ?? mitigatedAndAcceptedRisks?.mitigatedRisks ?? 0);
        const totalAccepted = Number(createdRisksAndTasks?.allAcceptedRisksCount ?? mitigatedAndAcceptedRisks?.acceptedRisks ?? 0);

        const mineCreated = Number(createdRisksAndTasks?.mineCreatedRisksCount ?? 0);
        const mineMitigated = Number(createdRisksAndTasks?.mineMitigatedRisksCount ?? 0);
        const mineAccepted = Number(createdRisksAndTasks?.mineAcceptedRisksCount ?? 0);

        const chartData = {
            series: [
                {
                    name: t("Total"),
                    data: [totalCreated, totalMitigated, totalAccepted],
                },
                {
                    name: t("Mine"),
                    data: [mineCreated, mineMitigated, mineAccepted],
                },
            ],
            options: {
                chart: {
                    toolbar: { show: false },
                },
                noData: {
                    text: t("There is no data"),
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "55%",
                        endingShape: "rounded",
                    },
                },
                dataLabels: { enabled: false },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ["transparent"],
                },
                colors: ["#5B3E62", "#78E09B"],
                xaxis: {
                    categories: [t("Total Risks"), t("Mitigated Risks"), t("Accepted Risks")],
                    labels: {
                        style: { cssClass: "font-size-12" },
                    },
                },
                yaxis: {
                    min: 0,
                    forceNiceScale: true,
                    labels: {
                        formatter: (val) => `${Math.round(Number(val) || 0)}`,
                    },
                },
                legend: {
                    position: "bottom",
                    horizontalAlign: "left",
                    markers: { radius: 12 },
                },
                grid: { borderColor: "#f1f1f1" },
                fill: { opacity: 1 },
                tooltip: {
                    y: {
                        formatter: (val) => `${Math.round(Number(val) || 0)}`,
                    },
                },
            },
        };

        if (isFetching) {
            return (
                <Card className="mb-3 card_box_Shadow h-100 w-100">
                    <CardBody>
                        <div className="dt-field dt-skeleton mb-3" style={{ width: "60%", height: "24px" }} />
                        <div className="dt-field dt-skeleton" style={{ width: "100%", height: "280px" }} />
                    </CardBody>
                </Card>
            );
        }

    return (
        <Card className="mb-3 card_box_Shadow h-100 w-100">
            <CardBody>
                <CardTitle tag="h6" className="mb-3">
                    {t("The Number of Mitigated and Accepted Risks Created")}
                </CardTitle>
                <ReactApexChart options={chartData.options} series={chartData.series} type="bar" height={300} />
            </CardBody>
        </Card>
    );
    }
);

export default withNamespaces()(MitigatedAndAcceptedRisksCreated);
